import './App.css';

import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner';

import PhoneBtn from './components/MainPage/PhoneBtn';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import BtnToTop from './components/MainPage/BtnToTop';
import { useLanguage } from './hooks';
import Home from './pages';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { PrivacyConsentProvider } from './privacy/PrivacyConsent';

const Model2 = lazy(() => import('./pages/Model2'));
const Model3 = lazy(() => import('./pages/Model3'));
const Model4 = lazy(() => import('./pages/Model4'));
const Model6 = lazy(() => import('./pages/Model6'));
const Diane = lazy(() => import('./pages/Diane'));
const Vacancy = lazy(() => import('./pages/Vacancy'));
const News1 = lazy(() => import('./pages/News1'));
const News2 = lazy(() => import('./pages/News2'));
const News3 = lazy(() => import('./pages/News3'));
const Biogas = lazy(() => import('./pages/Biogas'));
const Co2 = lazy(() => import('./pages/Co2'));
const Cogeneration = lazy(() => import('./pages/Cogeneration'));
const Gas = lazy(() => import('./pages/Gas'));
const Powerengine = lazy(() => import('./pages/PowerEngine'));
const Trigeneration = lazy(() => import('./pages/Trigeneration'));
const Project1 = lazy(() => import('./pages/Project1'));
const Project2 = lazy(() => import('./pages/Project2'));
const Project3 = lazy(() => import('./pages/Project3'));
const Project4 = lazy(() => import('./pages/Project4'));
const BroadXii = lazy(() => import('./pages/BroadXii'));

const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#1a1a2e',
    }}
  >
    <ThreeDots
      height="60"
      width="60"
      color="#3b82f6"
      ariaLabel="three-dots-loading"
      visible={true}
    />
  </div>
);

const LazyRoute = ({ children }) => <Suspense fallback={<LoadingFallback />}>{children}</Suspense>;

function AppContent() {
  useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Router>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PhoneBtn />
      <BtnToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route
          path="/cogeneration"
          element={
            <LazyRoute>
              <Cogeneration />
            </LazyRoute>
          }
        />
        <Route
          path="/powerengine"
          element={
            <LazyRoute>
              <Powerengine />
            </LazyRoute>
          }
        />
        <Route
          path="/co2"
          element={
            <LazyRoute>
              <Co2 />
            </LazyRoute>
          }
        />
        <Route
          path="/biogas"
          element={
            <LazyRoute>
              <Biogas />
            </LazyRoute>
          }
        />
        <Route
          path="/gas"
          element={
            <LazyRoute>
              <Gas />
            </LazyRoute>
          }
        />
        <Route
          path="/trigeneration"
          element={
            <LazyRoute>
              <Trigeneration />
            </LazyRoute>
          }
        />
        <Route
          path="/model2"
          element={
            <LazyRoute>
              <Model2 />
            </LazyRoute>
          }
        />
        <Route
          path="/model3"
          element={
            <LazyRoute>
              <Model3 />
            </LazyRoute>
          }
        />
        <Route
          path="/model4"
          element={
            <LazyRoute>
              <Model4 />
            </LazyRoute>
          }
        />
        <Route
          path="/model6"
          element={
            <LazyRoute>
              <Model6 />
            </LazyRoute>
          }
        />
        <Route
          path="/diane"
          element={
            <LazyRoute>
              <Diane />
            </LazyRoute>
          }
        />
        <Route
          path="/broadxii"
          element={
            <LazyRoute>
              <BroadXii />
            </LazyRoute>
          }
        />
        <Route
          path="/news1"
          element={
            <LazyRoute>
              <News1 />
            </LazyRoute>
          }
        />
        <Route
          path="/news2"
          element={
            <LazyRoute>
              <News2 />
            </LazyRoute>
          }
        />
        <Route
          path="/news3"
          element={
            <LazyRoute>
              <News3 />
            </LazyRoute>
          }
        />
        <Route
          path="/project1"
          element={
            <LazyRoute>
              <Project1 />
            </LazyRoute>
          }
        />
        <Route
          path="/project2"
          element={
            <LazyRoute>
              <Project2 />
            </LazyRoute>
          }
        />
        <Route
          path="/project3"
          element={
            <LazyRoute>
              <Project3 />
            </LazyRoute>
          }
        />
        <Route
          path="/project4"
          element={
            <LazyRoute>
              <Project4 />
            </LazyRoute>
          }
        />
        <Route
          path="/vacancy"
          element={
            <LazyRoute>
              <Vacancy />
            </LazyRoute>
          }
        />
      </Routes>
      <Footer />
    </Router>
  );
}

function App() {
  return (
    <PrivacyConsentProvider>
      <AppContent />
    </PrivacyConsentProvider>
  );
}

export default App;
